/**
 * QA-479 / QA-507 — 공통 동의 4종(고도몰 상품 [이벤트 수집 항목 → 개별동의] eventopt3~6).
 *
 * 문구는 몰별로 한 곳([동의 문구 관리], catalog consent-templates)에서 관리하고, 상품은 사용 여부만 고른다
 * (상품 commonConsentCodes — PUT null = 그대로, [] = 모두 사용 안 함). 이관 상품은 고도몰 사용함 값이 그대로 들어와 있다.
 */
export const COMMON_CONSENT_CODES = ['PRIVACY', 'WITHDRAWAL_RESTRICTION', 'DELIVERY_SCHEDULE', 'GUARDIAN'] as const;
export type CommonConsentCode = (typeof COMMON_CONSENT_CODES)[number];

/** BO 표시 이름(국내몰 기본 제목과 같다 — catalog V146). */
export const COMMON_CONSENT_LABELS: Record<CommonConsentCode, string> = {
  PRIVACY: '개인정보 활용 동의',
  WITHDRAWAL_RESTRICTION: '청약철회 불가 동의',
  DELIVERY_SCHEDULE: '배송일정 내용 동의',
  GUARDIAN: '미성년자 법정 대리인 동의',
};

const isCommonConsentCode = (v: string): v is CommonConsentCode =>
  (COMMON_CONSENT_CODES as ReadonlyArray<string>).includes(v);

/** 상세 응답(commerceMeta.commonConsentCodes) → 폼 값. 모르는 코드는 버리고 표준 순서로. */
export const commonConsentCodesFromDetail = (raw: ReadonlyArray<string> | null | undefined): CommonConsentCode[] => {
  const set = new Set((raw ?? []).filter(isCommonConsentCode));
  return COMMON_CONSENT_CODES.filter((c) => set.has(c));
};
